<div class="ap-margin-bottom-4 ap-margin-top-4 ap-display-block">
    <p><ap-content key="tokens.browser.start.content.description" [params]="browserNameParams"></ap-content></p>

    <p>
        <strong>{{ 'tokens.browser.start.content.warning' | apContent }}</strong>
        {{ 'tokens.browser.start.content.warning.content' | apContent }}
    </p>

    <p>
        <strong>{{ 'tokens.browser.start.content.advice' | apContent }}</strong>
        <ap-content [key]="getAdviceStepsContent()"></ap-content>
        {{ 'tokens.browser.start.content.advice.conclusion' | apContent }}
    </p>

    <ap-button (onClick)="onNext()" data-bb="next">
        {{ 'tokens.browser.start.content.next' | apContent }}
    </ap-button>

    <div>
        <ap-button (onClick)="onBack()" data-bb="back" [text]="true">
            {{ 'tokens.browser.start.content.back' | apContent }}
        </ap-button>
    </div>
</div>
